import { TClientForm } from "@shared/pages/registration/registration-module/registration-form/types";

export const MIN_LOGIN_CHARS = 3;
export const MIN_PASS_CHARS = 6;

export const serverErrors: Record<
  string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { field: keyof TClientForm; id: string; variables: any }
> = {
  "Email already has been register": {
    field: "email",
    id: "server-email-already-exist",
    variables: {},
  },
  "Referral code must be from 3 to 20 symbols": {
    field: "referralCode",
    id: "server-refcode-error",
    variables: { min: 3, max: 20 },
  },
};
